module.exports = ["pont most","%s másodperce","%s perce","%s órája","%s napja","%s hete","%s hónapja","%s éve"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-timeago/locales/hu-HU.json
// module id = Yjm8
// module chunks = 1